import { TailwindColor } from '@repo/tailwind-config/tailwind.vars'

type Props = {
  color1: TailwindColor
  color2: TailwindColor
}

const LoginGroupOneIcon: React.FC<Props> = ({ color1, color2 }) => {
  return (
    <svg
      width="382"
      height="382"
      viewBox="0 0 382 382"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M254.131 127.063C254.131 143.749 250.845 160.272 244.459 175.688C238.073 191.104 228.714 205.111 216.915 216.91C205.115 228.709 191.108 238.069 175.691 244.454C160.275 250.84 143.752 254.126 127.066 254.126L127.066 127.063L254.131 127.063Z"
        fill="white"
      />
      <path
        d="M254.063 127.002C270.749 127.002 287.272 130.288 302.688 136.674C318.104 143.06 332.111 152.419 343.91 164.218C355.709 176.017 365.069 190.025 371.454 205.441C377.84 220.858 381.126 237.381 381.126 254.067L254.063 254.067L254.063 127.002Z"
        fill={color2}
      />
      <path
        d="M127.063 255.002C143.749 255.002 160.272 258.288 175.688 264.674C191.104 271.06 205.111 280.419 216.91 292.218C228.709 304.017 238.069 318.025 244.454 333.441C250.84 348.858 254.126 365.381 254.126 382.067L127.063 382.067L127.063 255.002Z"
        fill={color1}
      />
      <path
        d="M127.065 327.929C134.465 327.929 141.792 329.329 148.629 332.05C155.465 334.771 161.677 338.759 166.91 343.787C172.142 348.814 176.293 354.782 179.125 361.351C181.957 367.92 183.414 374.96 183.414 382.07L127.065 382.07L127.065 327.929Z"
        fill={color2}
      />
      <circle cx="317.525" cy="318.525" r="63.525" fill="white" />
      <ellipse cx="317.937" cy="318.938" rx="30.9371" ry="30.9377" fill={color1} />
    </svg>
  )
}

export default LoginGroupOneIcon
